/**
 * MenuSports queries
 */

import gql from 'graphql-tag'

export const categoriesQuery = gql`
  query categories($sportId: Int!, $genderId: Int, $fromTop: Boolean, $onlyEvo: Boolean) {
    categories: categoriesSport(sportId: $sportId, genderId: $genderId, fromTop: $fromTop, onlyEvo: $onlyEvo) {
      id
      name
      totalCore: total_core
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      reseller {
        status
        comission
        inline
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MenuSports/data.ts